<div (scroll)="onElementScroll()" class="mobile-welcome-screen">
  <div class="section1">
    <img alt="" class="section1__trade-logo" src="{{ welcomeModalData?.logo }}" />
    <div class="section1__titles">
      <h4>Welcome to your</h4>
      <h1
        [ngStyle]="{ color: '#' + welcomeModalData?.primaryColor }"
        [innerHTML]="modalTemplateData[0]?.title ?? 'Mortgage Monitor'"></h1>
      <div class="description_text m-a mt-3">
        <span>
          {{ modalTemplateData[0].description }}
        </span>
      </div>
    </div>
    <div class="section1__monitor-logo">
      <shared-icon
        [fill]="'#' + welcomeModalData?.primaryColor"
        icon="arrow-down"
        height="6"
        width="9" />
    </div>
  </div>

  @for (item of modalTemplateData.slice(1); track item; let i = $index) {
    <ng-container
      *ngTemplateOutlet="
        stepTemplate;
        context: {
          primaryColor: welcomeModalData?.primaryColor,
          sectionTitle: item.mobileTitle,
          sectionDescription: item.description,
          imgPath: item.imgMobile,
          showDivider: i < modalTemplateData.length - 2,
        }
      " />
  }
  @if (!welcomeModalData.isExperianCompany) {
    <div class="section5">
      <div class="section5__content">
        <h4>Important</h4>
        <span
          >Please bookmark your Dashboard and return to it to update your details if your situation
          changes. The more accurate and up to date this data is, the better our search results will
          be.</span
        >
      </div>
    </div>
  }
</div>
<div [@slide]="showButton ? 'up' : 'down'" class="start-btn-wrapper">
  <button pButton class="p-button p-button-company-color" (click)="cancelTutorials()">
    Let’s start
  </button>
</div>

<ng-template
  #stepTemplate
  let-imgPath="imgPath"
  let-primaryColor="primaryColor"
  let-sectionDescription="sectionDescription"
  let-sectionTitle="sectionTitle"
  let-showDivider="showDivider">
  <div class="section">
    <h3 class="section-title">{{ sectionTitle }}</h3>
    <img [src]="imgPath" alt="daily-compare-img" class="w-100" />
    <span class="description_text">
      {{ sectionDescription }}
    </span>
    @if (showDivider) {
      <div [ngStyle]="{ background: '#' + primaryColor }" class="vertical-box"></div>
    }
  </div>
</ng-template>
